import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { decodeTokens, getAppConfig, getAuthInfo } from '../../utils';

export const Rum = () => {
  const { xbsEnvironment, xbsEnvironmentShort, dataDogRumConfig } = getAppConfig();

  useEffect(() => {
    if (!dataDogRumConfig?.[xbsEnvironment]?.applicationId) return;

    datadogRum.init({
      applicationId: dataDogRumConfig[xbsEnvironment].applicationId,
      clientToken: dataDogRumConfig[xbsEnvironment].clientToken,
      site: 'datadoghq.com',
      service: 'tpiq-reports-micro-ui',
      version: '1.1.0',
      env: xbsEnvironment,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'allow',
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      enableExperimentalFeatures: ['feature_flags'],
      silentMultipleInit: true,
      allowedTracingUrls: [`https://proxy.${xbsEnvironmentShort}xbs.com/`],
      sessionPersistence: 'memory'
    });

    const { authToken } = getAuthInfo();
    const decodedToken = decodeTokens(authToken);
    if (decodedToken) {
      datadogRum.setUser({
        id: decodedToken.userId,
        email: decodedToken.email
      });
    }
  }, [xbsEnvironment, xbsEnvironmentShort, dataDogRumConfig]);

  return null;
};
